import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
import { useRef } from 'react';
import { useTrackMarketplaceEvent } from '../../../hooks/useTrackMarketplaceEvent';
import { getSearchResultViewedEvent } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultViewTracker(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackedRef = useRef(false);
  return /*#__PURE__*/_jsx(IntersectionObserver, {
    onIntersectionChange: ({
      observer,
      entries
    }) => {
      if (entries[0].isIntersecting && !trackedRef.current) {
        trackMarketplaceEvent(getSearchResultViewedEvent(props));
        trackedRef.current = true;
        observer.disconnect();
      }
    },
    renderContent: () => children
  });
}